<div class="auth-wrapper d-flex no-block justify-content-center align-items-center" [style.background-color]="environment['AuthWrapperBg'] ? environment['AuthWrapperBg'] : '#272b34'"
     [style]="environment.loginbgPath.charAt(0) == '#'? ('background-color: ' + environment.loginbgPath) : ('background-image:url('+ environment.loginbgPath +')')"
>
  <div class="auth-box m-3 m-md-0">
    <div id="loginform" >
      <div class="logo">
        <span class="db"><img [src]="environment.logoPath" style="width: -webkit-fill-available; width: -moz-available;" alt="logo" /></span>
        <br>
        <br>
        <h5 class="font-medium m-b-20 text-white">Log In</h5>
        <h6 class="font-medium m-b-20">{{environment.loginMsg}}</h6>
      </div>
      <!-- Form -->
      <div class="row">
        <div class="col-12">
          <form class="form-horizontal m-t-20"[formGroup]="loginForm" (submit)="onSubmit()">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><i class="ti-user"></i></span>
              </div>
              <input formControlName="username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" type="text" class="form-control" placeholder="Username o Email" aria-label="Username"
                aria-describedby="basic-addon1">
              <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                <div *ngIf="f.username.errors.required">Username richiesto</div>
              </div>
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon2"><i class="ti-pencil"></i></span>
              </div>
              <input [type]="mostrapassword ? 'text' : 'password'" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
              class="form-control" placeholder="Password" aria-label="Password" aria-describedby="basic-addon1">
              <div class="input-group-append">
                <button class="btn mr-0 btn-outline-white" type="button" (click)="mostrapw()"><i class="fas " [ngClass]="{'fa-eye': !mostrapassword, 'fa-eye-slash': mostrapassword}"></i></button>
              </div>
              <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                <div *ngIf="f.password.errors.required">Password richiesta</div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <div class="custom-control custom-checkbox d-flex">
                  <!-- <input type="checkbox" class="custom-control-input" id="customCheck1"> TODO: tasto ricordami
                  <label class="custom-control-label font-14" for="customCheck1">Remember me</label> -->
                  <a (click)="showforgot()" id="to-recover"
                    class=" font-14 ml-auto"><i class="fa fa-lock m-r-5"></i> Recupera password</a>
                </div>
              </div>
            </div>
            <div class="text-center">
              <div class="col-xs-12 p-b-20">
                <button [disabled]="loading" class="btn btn-block btn-lg btn-info">Log In</button>
              </div>
              <!-- <div *ngIf="error">{{error}}</div> -->
            </div>
            <div class="form-group m-b-0 m-t-10 " *ngIf="registrazione">
              <div class="col-sm-12 text-center ">
                Non sei ancora registrato?
                <br>
                <a *ngIf="!environment.Wp" href="/Login/SignUp/ac" class="text-info m-l-5 "><b>Registrati come Acquirente</b></a>
                <a *ngIf="environment.Wp" href="/Login/SignUp" class="text-info m-l-5 "><b>Registrati</b></a>
                <br>
                <a  *ngIf="!environment.Wp" href="/Login/SignUp/c" class="text-info m-l-5 "><b>Registrati come Grossista</b></a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
